import './back-to-top.html.twig';
import './back-to-top.scss';

export default function () {
  const backToTop = document.querySelector('.back-to-top');

  if (!backToTop) {
    return;
  }

  const btnVisibility = () => {
    if (window.scrollY > window.innerHeight) {
      backToTop.style.visibility = 'visible';
    } else {
      backToTop.style.visibility = 'hidden';
    }
  };

  document.addEventListener('scroll', () => {
    btnVisibility();
  });

  backToTop.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
}
